import { Language, LocalStorageKey, NewEntityId } from "../data/constants";
import { ConfirmationMailHistoryEntryViewModel } from "./ConfirmationMailHistoryEntryViewModel";
import { ExamTemplateWithStructureIndex } from "./Exam";
import { ExamDayViewModel } from "./ExamDayViewModel";
import { LocationViewModel } from "./LocationViewModel";

export interface ExamSessionViewModel {
  from: Date;
  id: string;
  locations: LocationViewModel[];
  published: boolean;
  sessionKeyDE: string;
  sessionKeyEN: string;
  sessionKeyFR: string;
  sessionKeyIT: string;
  signupEndDate: Date;
  signupStartDate: Date;
  to: Date;
  examDays: ExamDayViewModel[];
  surveyDeadline?: Date;
  confirmationMailHistory: ConfirmationMailHistoryEntryViewModel[];
  examResultDate: Date;
  objectionDate: Date;
  gradingConferenceDate: Date;
  freeCancellationEndDate: Date;
  resultsArePublished: boolean;

  examsStartDate: Date;
  examsEndDate: Date;

  correctionStartDate: Date;
  correctionEndDate: Date;

  inspectionStartDate: Date;
  inspectionEndDate: Date;

  candidatePin: string;
  expertPin: string;

  isLife: boolean;

  expertAvailabilitySurveyDeadline: Date | null;

  exams: ExamTemplateWithStructureIndex[];
}

export const initialExamSession: ExamSessionViewModel = {
  from: new Date(),
  id: NewEntityId,
  locations: [],
  published: false,
  signupEndDate: new Date(),
  signupStartDate: new Date(),
  to: new Date(),
  examDays: [],
  surveyDeadline: new Date(),
  confirmationMailHistory: [],
  examResultDate: new Date(),
  objectionDate: new Date(),
  gradingConferenceDate: new Date(),
  freeCancellationEndDate: new Date(),
  resultsArePublished: false,
  examsStartDate: new Date(),
  examsEndDate: new Date(),
  correctionStartDate: new Date(),
  correctionEndDate: new Date(),
  inspectionStartDate: new Date(),
  inspectionEndDate: new Date(),
  exams: [],
  sessionKeyDE: "",
  sessionKeyEN: "",
  sessionKeyFR: "",
  sessionKeyIT: "",
  candidatePin: "",
  expertPin: "",
  isLife: false,
  expertAvailabilitySurveyDeadline: null,
};

export const GetLocalizedName = (examSession: ExamSessionViewModel): string => {
  const language = localStorage.getItem(LocalStorageKey.LastSelectedLanguageKey);

  switch (language) {
    case Language.EN:
      return examSession.sessionKeyEN;
    case Language.FR:
      return examSession.sessionKeyFR;
    case Language.IT:
      return examSession.sessionKeyIT;
  }

  return examSession.sessionKeyDE;
};

